export enum AssetListOrigin {
	NEWS = 'NEWS',
	FAVOURITES = 'FAVOURITES',
}

